import { createContext, useContext, useState, useEffect } from 'react';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [state, setState] = useState({ authenticated: false, features: {}, loading: true });

  useEffect(() => {
    fetch('/api/user/features/')
      .then(r => r.json())
      .then(data => setState({ authenticated: data.authenticated, features: data.features || {}, loading: false }))
      .catch(() => setState({ authenticated: false, features: {}, loading: false }));
  }, []);

  return (
    <UserContext.Provider value={state}>
      {children}
    </UserContext.Provider>
  );
}

export function useUser() {
  return useContext(UserContext);
}
